<template>
	<aside class="provider" v-if="data">
    <div @click="goToUrl()">
        <p class="location">{{ data.city.toUpperCase() }}, {{ data.state.toUpperCase() }}</p>
        <img class="image" :alt="data.hcpName" :src="data.imageUrl" />
        <div class="who">
            <label class="name">{{ data.hcpName }}</label>
            <label class="title">Hearing Care Practitioner</label>
        </div>
        <div class="information">
            <p class="distance" v-if="milesAway"><strong>{{ milesAway }}</strong> Miles Away</p>
            <template v-if="nextAvailableAppointment">
                <p class="nextAppointment">Next Available Appointment</p>
                <p class="appointmentTime">{{ nextAvailableAppointment }}</p>
            </template>
            <template v-else>
                <p class="nextAppointment">&nbsp;</p>
                <p class="appointmentTime">&nbsp;</p>
            </template>
        </div>
    </div>
		<div class="footer-actions">
			<a class="btn-beltone dark" :href="`tel:${this.helpers().callCenterPhoneNumber()}`" target="_top">Call {{ this.helpers().callCenterPhoneNumber() }} to Schedule</a>
			<a :href="getLocationUrl()" target="_top" class="btn-beltone">Book Online</a>
		</div>
	</aside>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Services from '../../mixins/services';
import moment from "moment";

export default {
	mixins: [Services],
	props: ['data'],
	components: {
	},
	data: function () {
		return {
		}
	},
	computed: mapState({
		geoLocation: state => state.LocationSearch.geoLocation,
		globals: state => state.LocationSearch.globals,
		milesAway() {
			return Math.round(this.data.milesAway * 100) / 100
		},
		nextAvailableAppointment() {
			if (this.data.nextAvailableAppointment === '0001-01-01T00:00:00') {
				return null;
			}
			let _dateTime = this.data.nextAvailableAppointment;
			return moment(_dateTime).format('dddd, MMM. Do @ h:mm a');
		},
	}),
	methods: {
		goToUrl() {
      window.top.location.href = this.getLocationUrl();
		},
		// bookOnline() {
    //     window.top.location.href = `${this.getLocationUrl()}#scheduleOnline`;
		// },
		getLocationUrl() {
			return `${document.referrer}${this.data.clinicUrl.substring(1)}`;
    }
	},
	mounted() {

	},
	created() {
	}
}
</script>
